import { action, createStore, persist } from "easy-peasy";

const store = createStore(
  persist(
    {
      itemMeasurements: [],
      setItemMeasurements: action((state, payload) => {
        state.itemMeasurements = payload;
      }),
      defaultCustomer: {},
      setDefaultCustomer: action((state, payload) => {
        state.defaultCustomer = payload;
      }),
      generalSettings: {
        convertToTonsAndPcs: false,
      },
      setGeneralSettings: action((state, payload) => {
        state.generalSettings = payload;
      }),
    },
    {
      storage: "localStorage",
    }
  )
);

export default store;
